import React, { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import { useStateContext } from '../../Contexts/ContextProvider';
import { FormActions } from '../../componants/Workspace';

const AddQuiz = () => {
  const { id } = useParams();
  const { SetNotification } = useStateContext();
  const navigate = useNavigate();

  const questionRef = useRef(null);
  const [options, setOptions] = useState(['', '']);
  const [isSending, setIsSending] = useState(false);

  const handleOptionChange = (index, value) => {
    const next = [...options];
    next[index] = value;
    setOptions(next);
  };

  const addOption = () => setOptions((prev) => [...prev, '']);
  const removeOption = (index) =>
    setOptions((prev) => (prev.length > 2 ? prev.filter((_, i) => i !== index) : prev));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);

    const cleaned = options.map((o) => o.trim()).filter((o) => o.length > 0);
    if (cleaned.length < 2) {
      SetNotification('Please provide at least 2 options', 'danger');
      setIsSending(false);
      return;
    }

    try {
      const response = await AxiosClient.post(`/sessions/${id}/quizzes`, {
        question: questionRef.current.value,
        options: cleaned,
      });
      if (response.status === 201) {
        SetNotification('Quiz created successfully', 'success');
        navigate(`/sessions/${id}`);
      }
    } catch (error) {
      const msg = error.response?.data?.message || 'Error creating quiz';
      SetNotification(msg, 'danger');
    }
    setIsSending(false);
  };

  return (
    <div className="m-4">
      <h3>Create a Quiz</h3>
      <form className="form-group" onSubmit={handleSubmit}>
        <h5>Quiz Question</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter quiz question" ref={questionRef} required />
        </div>

        <h5>Options</h5>
        {options.map((opt, index) => (
          <div className="d-flex gap-2 mb-2" key={index}>
            <input
              type="text"
              className="form-control"
              placeholder={`Option ${index + 1}`}
              value={opt}
              onChange={(e) => handleOptionChange(index, e.target.value)}
              required
            />
            <button
              type="button"
              className="btn btn-outline-danger"
              onClick={() => removeOption(index)}
              disabled={options.length <= 2}
            >
              X
            </button>
          </div>
        ))}

        <button type="button" className="btn btn-outline-secondary mb-3" onClick={addOption}>
          + Add option
        </button>

        <hr />

        <FormActions>
          {isSending ? <span role="status">Creating quiz...</span> : (
            <button type="submit" className="btn btn-primary">Create quiz</button>
          )}
        </FormActions>
      </form>
    </div>
  );
};

export default AddQuiz;
